import React from "react";
import { Alert } from "reactstrap";
import { isMarketerReadOnly } from "../../helpers/adminRole";

/** Shown on partner context pages when admin role is marketer (view-only). */
export default function PartnerReadOnlyBanner() {
  if (!isMarketerReadOnly()) return null;
  return (
    <div className="container-fluid pt-3">
      <Alert color="info" className="mb-0">
        <i className="mdi mdi-eye-outline me-2" />
        View-only access — you can browse partner data but cannot make changes.
      </Alert>
    </div>
  );
}
